// extracted by mini-css-extract-plugin
export var input = "Input-module--input--sqNFt";